<template>
  <div class="officeDetail">
    <div class="wrap">
      <div class="project-intro">
        <Row>
          <Col span="16">
            <swiper-banner style="margin-bottom: 33px" :imageList="imageList" />
            <div class="project-intro-cont">
              <h3>{{ room.highlights }}</h3>
              <div class="intro-cont-box">
                <Row class="cont-part1">
                  <Col span="6">
                    <div class="img-l">
                      <img src="../assets/images/web/ico-fpic1.png" />
                    </div>
                    <div class="txt-r">
                      <div>{{ room.rentPrice }}元/m²/天</div>
                      <p>租金</p>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="img-l">
                      <img src="../assets/images/web/ico-fpic2.png" />
                    </div>
                    <div class="txt-r">
                      <div>{{ room.propertyFee }}元/m²/月</div>
                      <p>物业费</p>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="img-l">
                      <img src="../assets/images/web/ico-fpic3.png" />
                    </div>
                    <div class="txt-r">
                      <div>{{ room.area }}m²</div>
                      <p>面积</p>
                    </div>
                  </Col>
                </Row>
              </div>
              <h3>基本信息</h3>
              <div class="intro-cont-box">
                <Row class="tit-dec">
                  <Col span="6"> <span>楼栋：</span>{{ room.buildingName }} </Col>
                  <Col span="6"> <span>楼层：</span>{{ room.floorNum }} </Col>
                  <Col span="6"> <span>房号：</span>{{ room.roomName }} </Col>
                  <Col span="6"> <span>交付标准：</span>{{ room.deliveryMethod }} </Col>
                  <Col span="6"> <span>项目：</span>{{ room.projectName }} </Col>
                  <Col span="6"> <span>付款方式：</span>{{ room.paymentMethod }} </Col>
                  <Col span="6"> <span>最短租期：</span>{{ room.tenancy }}个月 </Col>
                  <Col span="6">
                    <span v-if="!room.isHaveRoom">起租期：</span>{{ room.tenancy }}
                    <span v-if="room.isHaveRoom">起租期：</span>现房
                  </Col>
                </Row>
              </div>
              <h3>设施情况</h3>
              <div class="intro-cont-box">
                <Row class="tit-dec">
                  <Col span="6"> <span>开园时间：</span>{{ room.completionTime }} </Col>
                  <Col span="6"> <span>层高：</span>{{ room.floorHeight }}米 </Col>
                  <Col span="6">
                    <span>公共会议：</span>{{ room.meetingRoomCount > 0 ? "有" : "无" }}
                  </Col>
                  <Col span="6"> <span>电梯：</span>{{ room.lift }} </Col>
                  <Col span="6"> <span>网络：</span>{{ room.network }} </Col>
                  <Col span="6"> <span>空调：</span>{{ room.airConditioner }} </Col>
                  <Col span="6">
                    <span>车位：</span
                    >{{ room.carNumber > 0 ? room.carNumber + "+" : "" }}
                  </Col>
                  <Col span="6">
                    <span>车位租金：</span>{{ room.carMinRent }}-
                    {{ room.carMaxRent }} 元/月
                  </Col>
                </Row>
              </div>
              <h3>服务设施</h3>
              <div class="intro-cont-box">
                <Row type="flex" justify="space-between" class="code-row-bg">
                  <Col span="6" :key="item.id" v-for="item in contentList">
                    <div class="equ">
                      <img :src="item.imageUrls" />
                      <p>{{ item.title }}</p>
                    </div>
                  </Col>
                  <!-- <Col span="6">
                                        <div class="equ">
                                            <img src="../assets/images/web/equip-pic2.png"/>
                                            <p>健身房</p>
                                        </div>
                                    </Col>
                                    <Col span="6">
                                        <div class="equ">
                                            <img src="../assets/images/web/equip-pic3.png"/>
                                            <p>体育馆</p>
                                        </div>
                                    </Col>
                                    <Col span="6">
                                        <div class="equ">
                                            <img src="../assets/images/web/equip-pic4.png"/>
                                            <p>酒吧</p>
                                        </div>
                                    </Col>
                                    <Col span="6">
                                        <div class="equ">
                                            <img src="../assets/images/web/equip-pic5.png"/>
                                            <p>餐厅</p>
                                        </div>
                                    </Col> -->
                </Row>
              </div>
              <h3>位置信息</h3>
              <div class="intro-cont-box">
                <Row class="office-addr">
                  <Col span="12">
                    <!-- <div class="office-map">
                                            <img src="../assets/images/web/office-map.jpg"/>
                                        </div> -->
                      <!-- 高德地图                   -->
                    <!-- <MapContainer
                      ref="mapContainer"
                      height="400px"
                      @loaded="hanldeMapLoaded"
                    >
                    </MapContainer> -->
                    <img :src="getDiTuUrl">
                  </Col>
                  <Col span="12">
                    <div class="addr-msg">
                      <ul>
                        <li>
                          <div class="iconL">
                            <Icon type="md-pin" />
                          </div>
                          <div class="msgR">
                            <p>地址</p>
                            <div>{{ project.address }}</div>
                          </div>
                        </li>
                        <li>
                          <div class="iconL">
                            <Icon type="md-bus" />
                          </div>
                          <div class="msgR">
                            <p>班车</p>
                            <div>{{ project.vehicle }}</div>
                          </div>
                        </li>
                        <li>
                          <div class="iconL">
                            <Icon type="md-subway" />
                          </div>
                          <div class="msgR">
                            <p>地铁</p>
                            <div>地铁13号线中科路站</div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col span="8">
            <div class="project-introR">
              <!--<div class="project-cont">
                                <h2>盛大天地·源创谷</h2>
                                <h4>张江科学城内的大型科创园区</h4>
                                <div class="line"><span>&nbsp;</span></div>
                                <div class="dec">
                                <span>项目总建筑面积约15万平米，园区不仅具备完善的商业、商务、文化娱乐设施和青年社区配套，并拥享创新服务平台和盛大全方位优质资源的投入，形成了完善的助推企业发展的全生命周期生态系统。目前，园区内已汇聚了大量互联网、软件开发、芯片研发、智能系统、大数据等行业的优质企业，并入驻一批创新型初创、快速发展企业。未来将始终秉承创新理念，致力于发展成为以互联网、信息科技、文化创意等创新型产业为主，企业发展与人文建设并重的“创新生态之城”。
                                </span>
                                </div>
                            </div>-->
              <ProjectCont
                :tit="project.projectName"
                :msg="project.introduction"
                :subheading="project.subtitle"
              />
              <div class="appoint-box">
                <Affix :offset-top="70">
                  <AppointmentR
                    v-if="roomId != 0"
                    :msg="appointMsg"
                    :tit="appointTit"
                    :roomId="roomId"
                    :projectId="projectId"
                    :recordType="0"
                    :btnTxt="appointBtnTxt"
                  />
                </Affix>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectCont from "@/components/ProjectCont.vue";
import AppointmentR from "@/components/AppointmentR.vue";
import swiperBanner from "@/components/swiperBanner.vue";
//import MapContainer from "@/components/MapContainer.vue";
export default {
  name: "officeDetail",
  components: {
    AppointmentR: AppointmentR,
    swiperBanner: swiperBanner,
    ProjectCont: ProjectCont,
    //MapContainer: MapContainer,
  },
  data() {
    return {
      appointBtnTxt:"提交预约",
      projectTit: "盛大天地·源创谷",
      subHeading: "张江科学城内的大型科创园区",
      projectDec:
        "项目总建筑面积约15万平米，园区不仅具备完善的商业、商务、文化娱乐设施和青年社区配套，并拥享创新服务平台和盛大全方位优质资源的投入，形成了完善的助推企业发展的全生命周期生态系统。目前，园区内已汇聚了大量互联网、软件开发、芯片研发、智能系统、大数据等行业的优质企业，并入驻一批创新型初创、快速发展企业。未来将始终秉承创新理念，致力于发展成为以互联网、信息科技、文化创意等创新型产业为主，企业发展与人文建设并重的“创新生态之城。",
      appointMsg: "填写您的信息，获取个更多房屋租赁信息。",
      appointTit: "预约参观",
      roomId: 0,
      room: {},
      projectId: 0,
      project: {},
      contentList: [],
      imageList: [],
    };
  },
  methods: {
    hanldeMapLoaded({ map, AMap }) {
      console.log(map);
      this.AMap = AMap;
      this.getProject().then(() => {
        var center = new AMap.LngLat(this.project.longitude, this.project.latitude, true);
        let marker = new AMap.Marker({
          position: center,
          offset: [0, -10],
        });
        map.add(marker);
        map.setZoomAndCenter(14, center, true, 400);
      });
    },
    getProject() {
      this.loading = true;
      return this.$http
        .get("/api/services/app/CommonWeb/GetProjectById?id=" + this.projectId)
        .then((res) => {
          this.project = res.data.result;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getRoom(roomId) {
      this.loading = true;
      this.$http
        .get("api/services/app/CommonWeb/GetRoomInfo?id=" + roomId)
        .then((res) => {
          this.room = res.data.result;
          this.room.imageUrl.forEach((item) => {
            this.imageList.push(item.url);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getColumnByName() {
      this.loading = true;
      this.$http
        .get(
          "api/services/app/CommonWeb/GetColumnByName?businessType=1&name=服务设施&businessId=" +
            this.projectId
        )
        .then((res) => {
          this.contentList = res.data.result.columnContents;
          console.log(this.contentList);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
  },
  computed:{
    //地图url
    getDiTuUrl(){
      return "http://api.tianditu.gov.cn/staticimage?center=121.6050,31.1719&width=350&height=350&zoom=13&layers=vec_c,cva_c&markers="+this.project.longitude+","+this.project.latitude+"&tk=8fbffc7a4eb9a0e195aa60425ca38861"
    }
  },
  mounted() {
    this.roomId = parseInt(this.$route.query.roomId);
    this.projectId = parseInt(this.$route.query.projectId);
    if (this.roomId != 0) {
      this.getRoom(this.roomId);
    }
    if (this.projectId != 0) {
      this.getColumnByName();
    }
    this.getProject();
  },
};
</script>

<style lang="less">
.officeDetail {
  background-color: #fff;
  padding: 30px 0;
  .project-intro {
    .project-intro-cont {
      h3 {
        font-size: 18px;
        margin-bottom: 20px;
      }

      .intro-cont-box {
        margin-bottom: 60px;

        .cont-part1 {
          display: flex;
          justify-content: flex-start;

          .ivu-col-span-6 {
            display: flex;
            flex-flow: row;
            align-items: center;

            .img-l {
              margin-right: 15px;

              img {
                display: block;
              }
            }

            .txt-r {
              font-size: 16px;

              p {
                font-size: 12px;
                color: #999;
              }
            }
          }
        }

        .tit-dec {
          margin-bottom: -10px;
          font-size: 14px;

          .ivu-col-span-6 {
            margin-bottom: 20px;

            span {
              width: 70px;
              color: #666;
            }
          }
        }

        .code-row-bg {
          text-align: center;
          margin: 0 -10px;
          justify-content: flex-start;
          .ivu-col-span-6 {
            margin-bottom: 20px;

            .equ {
              margin: 0 10px;
              background-color: #fff;
              border: 1px solid #efefef;
              border-radius: 5px;

              img {
                width: 100%;
                height: 95px;
                border-radius: 5px;
                line-height: 0;
                display: block;
              }

              p {
                font-size: 14px;
                line-height: 32px;
              }
            }

            .equ:hover {
              box-shadow: 0px 0px 2px 0px rgba(70, 139, 254, 0.7);
            }
          }
        }

        .office-addr {
          .office-map {
            border: 1px solid rgba(0, 0, 0, 0.3);
            margin-right: 30px;

            img {
              width: 100%;
              height: 100%;
              line-height: 0;
              display: block;
            }
          }

          .addr-msg {
            padding-left: 30px;
            ul {
              li {
                display: flex;
                align-items: center;
                margin-bottom: 20px;

                .iconL {
                  background-color: #66cff2;
                  height: 30px;
                  line-height: 30px;
                  width: 30px;
                  text-align: center;
                  color: #fff;
                  font-size: 18px;
                  border-radius: 5px;
                  flex: none;
                }

                .msgR {
                  margin-left: 10px;
                  font-size: 14px;

                  p {
                    color: #3376fe;
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }
      }
    }

    .project-introR {
      padding-left: 30px;
    }
  }
}
</style>
